<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Wishlist" subtitle="Wishlist"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- wishlist area start-->
  <section class="cart-area pt-100 pb-100">
    <div class="container">
      <div *ngIf="wishlistService.getWishlistProducts().length === 0" class="text-center pt-50">
        <h3>No Wishlist Items Found</h3>
        <a routerLink="/shop" class="os-btn os-btn-black mt-20">Continue Shopping</a>
      </div>
      <div *ngIf="wishlistService.getWishlistProducts().length > 0" class="row">
        <div class="col-12">
          <div class="table-content table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="product-thumbnail">Images</th>
                  <th class="cart-product-name">Product</th>
                  <th class="product-price">Unit Price</th>
                  <th class="product-quantity">Quantity</th>
                  <th class="product-remove">Remove</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of wishlistService.getWishlistProducts()">
                  <td class="product-thumbnail">
                    <a [routerLink]="['/shop/product', item.id]">
                      <!-- <img [src]="item.img" alt="product-img"> -->
                      <img [src]="(item.product_image)?item.path+item.product_image:'assets/img/shop/product/product_1.png'" alt="product-img">
                    </a>
                  </td>
                  <td class="product-name">
                    <a [routerLink]="['/shop/product', item.id]">{{item.title}}</a>
                  </td>
                  <td class="product-price">
                    <!-- <span class="amount">₹{{item.price.toFixed(2)}}</span> -->
                    <span>₹{{ (item.sale_price)?item.sale_price.toFixed(2):item.regular_price.toFixed(2) }}</span>
                    <!-- <span *ngIf="item.sale_price" class="old-price">₹{{item.regular_price.toFixed(2)}}</span> -->
                  </td>
                  <td class="product-quantity">
                    <button (click)="cartService.addCartProduct(item)" class="os-btn os-btn-black">
                      Add TO Cart
                    </button>
                  </td>
                  <td class="product-remove">
                    <a (click)="wishlistService.removeWishlist(item)" class="cursor-pointer">
                      <i class="fa fa-times"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- wishlist area End-->

</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
